function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'vintage-black': 'rgb(21, 21, 21)','vintage-white': 'rgb(252, 244, 232)','pink': 'rgb(253, 191, 199)','light-pink': 'rgb(255, 225, 229)','heather-true-royal': 'rgb(83, 107, 167)','heather-slate': 'rgb(76, 98, 110)','heather-raspberry': 'rgb(210, 61, 98)','heather-midnight-navy': 'rgb(48, 45, 75)','heather-mauve': 'rgb(196, 115, 108)','heather-deep-teal': 'rgb(68, 112, 133)','deep-teal-heather': 'rgb(51, 92, 107)','heather-emerald': 'rgb(30, 44, 28)','asphalt': 'rgb(82, 81, 79)','steel-blue': 'rgb(102, 142, 167)','team-purple': 'rgb(35, 15, 70)','heather-prism-lilac': 'rgb(222, 175, 205)','military-green': 'rgb(77, 76, 55)','militant-green': 'rgb(126, 133, 96)','sage': 'rgb(158, 171, 150)','pebble': 'rgb(154, 135, 126)','black': 'rgb(12, 12, 12)','navy': 'rgb(33, 38, 66)','navy-blue': 'rgb(19, 25, 40)','naval': 'rgb(22, 19, 36)','true-royal': 'rgb(20, 73, 140)','forest-green': 'rgb(34, 46, 31)','charcoal': 'rgb(83, 78, 74)','indigo-blue': 'rgb(57, 93, 130)','maroon': 'rgb(114, 29, 55)','forest': 'rgb(34, 63, 36)','berry': 'rgb(142, 89, 123)','true-navy': 'rgb(36, 59, 90)','grey': 'rgb(146, 146, 143)','heather-orchid': 'rgb(194, 135, 141)','black-heather': 'rgb(14, 14, 14)','heather-forest': 'rgb(40, 51, 46)','heather-navy': 'rgb(68, 73, 91)','storm': 'rgb(159, 147, 147)','heather-team-purple': 'rgb(182, 128, 193)','heather-prism-dusty-blue': 'rgb(165, 200, 188)','heather-carolina-blue': 'rgb(171, 195, 239)','ocean-blue': 'rgb(169, 223, 246)','blue-day': 'rgb(169, 223, 246)','heather-olive': 'rgb(92, 85, 49)','heather-brown': 'rgb(106, 81, 58)','army': 'rgb(95, 88, 73)','dark-grey-heather': 'rgb(62, 60, 61)','lilac': 'rgb(239, 187, 227)','raspberry-marmalade': 'rgb(239, 187, 227)','heather-prism-ice-blue': 'rgb(195, 226, 227)','soft-pink': 'rgb(255, 216, 225)','heather-ice-blue': 'rgb(231, 253, 255)','citron': 'rgb(247, 254, 229)','dark-grey': 'rgb(42, 41, 41)','ash': 'rgb(240, 241, 234)','silver': 'rgb(227, 227, 221)','vintage-blue': 'rgb(98, 116, 155)','emerald': 'rgb(20, 44, 30)','throwback-black': 'rgb(23, 27, 25)','lightest-blue': 'rgb(207, 213, 225)','heather-columbia-blue': 'rgb(125, 149, 232)','sky-blue': 'rgb(214, 237, 247)','navy-blazer': 'rgb(23, 31, 44)','flat-dark-gray': 'rgb(67, 65, 61)','carolina-blue': 'rgb(141, 183, 246)','alpine-green': 'rgb(44, 73, 58)','sand': 'rgb(220, 202, 171)','emerald-triblend': 'rgb(20, 44, 30)','charcoal-black-triblend': 'rgb(23, 27, 25)','true-royal-triblend': 'rgb(46, 76, 134)','solid-black-triblend': 'rgb(16, 18, 17)','classic-navy': 'rgb(37, 43, 59)','cotton-pink': 'rgb(255, 233, 235)','stargazer': 'rgb(62, 115, 125)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
